export default function initScheduleModal() {
  const scheduleLinks = document.querySelectorAll('[href="#schedule-modal"]');
  const modal = document.querySelector('#schedule-modal');

  // Exit if required elements are not found
  if (!scheduleLinks.length || !modal) return;

  // Badge class mappings
  const BADGE_CLASSES = {
    'live online': 'badge-turquoise',
    'classroom-based': 'badge-orange',
    'home study': 'badge-sky-blue',
  };

  // Handle badge class updates
  const updateBadgeClass = (element, courseType) => {
    element.className = 'course-badge';
    const badgeClass = BADGE_CLASSES[courseType.trim().toLowerCase()];
    if (badgeClass) {
      element.classList.add(badgeClass);
    }
  };

  // Handle modal data population
  scheduleLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const courseCard = link.closest('.upcoming-course-card');
      if (!courseCard) return;

      // Get data from course card using destructuring
      const { textContent: date = '' } = courseCard.querySelector('[data-calendar-date]') || {};
      const { textContent: time = '' } = courseCard.querySelector('[data-calendar-time]') || {};
      const { textContent: courseType = '' } = courseCard.querySelector('[data-calendar-course-type]') || {};

      // Update modal elements
      modal.querySelector('[data-calendar-date]').textContent = date;

      const modalTime = modal.querySelector('[data-calendar-time]');
      if (modalTime) modalTime.textContent = time;

      const modalCourseType = modal.querySelector('[data-calendar-course-type]');
      if (modalCourseType && courseType) {
        modalCourseType.textContent = courseType;
        updateBadgeClass(modalCourseType, courseType);
      }
    });
  });
}
